export default "__VITE_ASSET__C47oixSV__"